<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      :max-width="maxWidth"
      @input="v => v || _closeDialog()"
    >
      <v-card>
        <v-card-title class="headline blue darken-1 white--text">
          {{ headText }}
        </v-card-title>

        <v-card-text v-if="description">
          {{ description }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            flat="flat"
            :disabled="processing"
            @click="cancelAction()"
          >
            {{ cancelBtnLabel }}
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            :loading="processing"
            @click="confirmAction()"
          >
            {{ confirmBtnLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    confirmBtnLabel: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: Number,
      default: 290,
    },
    cancelBtnLabel: {
      type: String,
      default: '',
    },
    headText: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    confirmAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: this.dialog,
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
  },
  methods: {
    _closeDialog() {
      this.cancelAction();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/ConfirmDialog.vue